import { observer } from 'mobx-react-lite';
import React from 'react';
import { List, Image, Popup } from 'semantic-ui-react';
import { Profile } from '../../../app/models/profile';
import { Link } from 'react-router-dom';
import { ProfileCard } from '../../profile/ProfileCard';

interface Props {
  attendees: Profile[];
}

const ActivityListItemAttendee: React.FC<Props> = observer(({ attendees }) => {
  const followingStyle = {
    borderColor: 'orange',
    borderWidth: 3,
  };

  return (
    <List horizontal>
      {attendees.map((attendee) => (
        <Popup
          hoverable
          key={attendee.username}
          trigger={
            <List.Item
              as={Link}
              key={attendee.username}
              to={`/profiles/${attendee.username}`}
            >
              <Image
                size="mini"
                circular
                bordered
                style={attendee.following ? followingStyle : null}
                src={attendee.image || '/assets/user.png'}
              />
            </List.Item>
          }
        >
          <Popup.Content>
            <ProfileCard profile={attendee} />
          </Popup.Content>
        </Popup>
      ))}
    </List>
  );
});

export { ActivityListItemAttendee };
